import config from './config';
// import * as PIXI from '../assets/scripts/pixi.min';
// import * as PIXI from 'pixi.js';
import {
  Application,
  Assets,
  Sprite,
  Graphics,
  Point,
  Text,
  TextStyle,
  Container,
  Rectangle,
  Polygon,
  deprecation
} from 'pixi.js';
import $ from '../assets/scripts/jquery-3.6.0.min';



var CustomTruckScienceRequirements = window.CustomTruckScienceRequirements;

var scalingFactor, mainHeight, topOffsetRequiredForAxisFlip;
//var lineWidth = 0.75, dimensionLineWidth = 0.5, tableCellLineWidth = 0.5, lineColour = 0x000000, lineAlpha = 1, wordWrapWidth;
var lineWidth = config.STANDARD_DRAWING_LINE_THICKNESS, dimensionLineWidth = 0.8, tableCellLineWidth = 0.65, lineColour = config.DRAWING_COLOURS.BLACK, lineAlpha = 0.6, wordWrapWidth, circleWidth = lineWidth, altCircleWidth = 4;
var graphicsObject  = new Graphics();
var curAlternateGraphicsObject = null;
var watermarkSprite = null;
var _resources;
let usePixelLine = true;
let app;
let appInitialisation;

// if (CustomTruckScienceRequirements.getBrowser() === config.BROWSER_NAME.CHROMEONANDROID) {
    // circleWidth = altCircleWidth;
// } 

function getGraphicsObject(getAsSprite) {
    
    //if (graphicsObject === null || graphicsObject === undefined || graphicsObject.children === null) {
    //    graphicsObject = new Graphics();
    //}

    if(getAsSprite) {
        var drawingTexture = graphicsObject.generateTexture();
        var drawingSprite = new Sprite(drawingTexture);
        return drawingSprite;
    } else {
        if (graphicsObject === undefined || graphicsObject === null) {
            graphicsObject = new Graphics();
        }
        return graphicsObject;
    }
    
}
function destroyGraphicsObject() {
    graphicsObject = null;
}
function setMainHeight(mH) {
    mainHeight = mH;
}
function setAlternateGraphicsObject(dimensionGraphicsObject) {
    curAlternateGraphicsObject = dimensionGraphicsObject;
}
//function setTopOffsetRequiredForAxisFlip(topOffset) {
//    topOffsetRequiredForAxisFlip = topOffset;
//}

function setScalingFactor(factor) {
    scalingFactor = factor;
}

function getPoint(point) {
    return new Point(point.x, point.y);
}

function getNewGraphicsObject(optionalEventMode) {
    let newGraphicsObject = new Graphics();
    newGraphicsObject.eventMode = optionalEventMode || config.PIXI_EVENT_MODE.NONE;

    return newGraphicsObject;
}
//function drawText(text, position, addToGraphics, anchorPoint, textAligment, font, optionalFontColour) {

//    var textGraphicsObject = new PIXI.Text(text, { font: font || '10px Arial', fill: optionalFontColour || 0x000000, align: textAligment || 'center', wordWrap: true, wordWrapWidth: wordWrapWidth });

//    var anchor = anchorPoint || { x: 0, y: 0 };

//    textGraphicsObject.anchor = new Point(anchor.x, anchor.y);
    
//    if (addToGraphics) {
//        //textGraphicsObject.position = new Point(Math.round(position.x * scalingFactor), mainHeight - (Math.round(position.y * scalingFactor)));
//        textGraphicsObject.position = new Point((position.x * scalingFactor), mainHeight - ((position.y * scalingFactor)));
//        graphicsObject.addChild(textGraphicsObject);
//    } else {
//        textGraphicsObject.position = new Point(position.x, position.y);
//    }
//    return textGraphicsObject;
//}

function drawText(text, position, addToGraphics, anchorPoint, textAligment, font, optionalFontColour) {
    
    let styleObject = { 
        fontFamily: font.fontFamily || 'Arial', 
        fontSize: font.fontSize || 10,
        fill: optionalFontColour || config.DRAWING_COLOURS.BLACK, 
        align: textAligment || 'center', 
        wordWrap: true, 
        wordWrapWidth: wordWrapWidth,
        fontWeight: font.fontWeight || 'normal', 
    };

    if (font.fontFamily === 'FontAwesome5ProTruckScience') {
        styleObject.fontWeight = 900;
    }

    // Inline the object literal to satisfy the v8 compiler and remove the warning
    var textGraphicsObject = new Text({
        text: text,
        style: styleObject,
        // You can now pass anchor and positioning directly in v8!
        anchor: anchorPoint || { x: 0, y: 0 },
        x: position.x,
        y: position.y,
        resolution: window.devicePixelRatio || 1
    });

    textGraphicsObject.roundPixels = true;

    if (addToGraphics) {
        graphicsObject.addChild(textGraphicsObject);
    } 

    return textGraphicsObject;
}

function drawInteractiveTextIcon(callbacks, cellHeight, text, position, addToGraphics, anchorPoint, textAligment, font, optionalFontColour) {

    var textGraphicsObject = drawText(text, position, addToGraphics, anchorPoint, textAligment, font, optionalFontColour);
    var containerPosition;
    var translateIconX = false;
    if (anchorPoint !== undefined) {
        containerPosition = {};
        if (anchorPoint.x === 1) {
            translateIconX = true;
            containerPosition.x = position.x - textGraphicsObject.width;
            containerPosition.y = position.y;
        } else {
            containerPosition = position;
        }
    } else {
        containerPosition = position;
    }
    var iconContainer = getDrawingContainer(containerPosition, textGraphicsObject.width, textGraphicsObject.height);
    if (translateIconX === true) {
        textGraphicsObject.position.x = textGraphicsObject.width;
    } else {
        textGraphicsObject.position.x = 0;
    }
    
    textGraphicsObject.position.y = (cellHeight - textGraphicsObject.height)/2;

    if (callbacks !== undefined) {
        iconContainer.eventMode = config.PIXI_EVENT_MODE.STATIC;
        iconContainer.cursor = config.PIXI_CURSOR_OPTION.POINTER;
        iconContainer.hitArea = new Rectangle(0,0, iconContainer.width, iconContainer.height);
        if (callbacks.mouseover !== undefined && typeof callbacks.mouseover === 'function') {
            // iconContainer.mouseover = callbacks.mouseover;
            iconContainer.on('mouseover', callbacks.mouseover);
        }
        if (callbacks.click !== undefined && typeof callbacks.click === 'function') {
            // iconContainer.click = callbacks.click;
            iconContainer.on('click', callbacks.click);
            // iconContainer.tap = callbacks.click;
            iconContainer.on('tap', callbacks.click);
        }
        if (callbacks.mouseout !== undefined && typeof callbacks.mouseout === 'function') {
            // iconContainer.mouseout = callbacks.mouseout;
            iconContainer.on('mouseout', callbacks.mouseout);
        }
        if (callbacks.mousemove !== undefined && typeof callbacks.mousemove === 'function') {
            // iconContainer.mousemove = callbacks.mousemove;
            iconContainer.on('mousemove', callbacks.mousemove);
        }
    }
    iconContainer.addChild(textGraphicsObject);
    return iconContainer;
    //return textGraphicsObject;
}


function setWordWrapWidth(www) {
    wordWrapWidth = www;
}

//function drawLine(startPoint, endPoint, addToGraphics, width, colour, alpha) {
//    var graphicsObjectToUse;

//    if (addToGraphics && addToGraphics === true) {
//        graphicsObjectToUse = getGraphicsObject();
//    } else if (curAlternateGraphicsObject !== null) {
//        graphicsObjectToUse = curAlternateGraphicsObject;
//    } else {
//        graphicsObjectToUse = new Graphics();
//    }

//    graphicsObjectToUse.lineStyle(width || lineWidth, colour || lineColour, alpha || lineAlpha);
//    graphicsObjectToUse.moveTo(startPoint.x, startPoint.y);
//    graphicsObjectToUse.lineTo(endPoint.x, endPoint.y);

//    if (addToGraphics === undefined || addToGraphics === false) {
//        return graphicsObjectToUse;
//    } 
//}
//function drawLine(graphicsObjectForLine, startPoint, endPoint, width, colour, alpha) {
//    graphicsObjectForLine.lineStyle(width || lineWidth, colour || lineColour, alpha || lineAlpha);
//    graphicsObjectForLine.moveTo(startPoint.x, startPoint.y);
//    graphicsObjectForLine.lineTo(endPoint.x, endPoint.y);
//}

// function drawLine(graphicsObjectToUse, startPoint, endPoint, addToGraphics, width, colour, alpha) {
//     //var graphicsObjectToUse;

//     //if (addToGraphics && addToGraphics === true) {
//     //    graphicsObjectToUse = getGraphicsObject();
//     //} else if (curAlternateGraphicsObject !== null) {
//     //    graphicsObjectToUse = curAlternateGraphicsObject;
//     //} else {
//     //    graphicsObjectToUse = new Graphics();
//     //}

//     graphicsObjectToUse
//         .moveTo(startPoint.x, startPoint.y)
//         .lineTo(endPoint.x, endPoint.y)
//         .stroke({ width: width || lineWidth, color: config.DRAWING_COLOURS.WHITE, alpha: alpha || lineAlpha });

//     graphicsObjectToUse.tint = colour || lineColour;

//     if (addToGraphics === undefined || addToGraphics === false) {
//         return graphicsObjectToUse;
//     }
// }

function drawLine(graphics, startPoint, endPoint, addToGraphics, width, colour, alpha) {
    let followTintPattern = true;
    let colourToUse = config.DRAWING_COLOURS.WHITE;
    if(!graphics.outline) {
        //this is to handle the scenario where the drawLine call is coming from drawing a dimension line and so graphics is a single grpahhics object not an object with an outline property
        let passedInGraphicsObject = graphics;
        graphics = {};
        graphics.outline = passedInGraphicsObject;
        followTintPattern = false;
        colourToUse = colour || lineColour;
    }

    graphics.outline
        .moveTo(startPoint.x, startPoint.y)
        .lineTo(endPoint.x, endPoint.y)
        .stroke({ width: width || lineWidth, color: colourToUse, alpha: alpha || lineAlpha, pixelLine: usePixelLine });

        if(followTintPattern) {
            let tintColour = colour || lineColour;
            if(graphics.outline.tint !== tintColour) {
                graphics.outline.tint = tintColour;
            }
        }
    

    if (addToGraphics === undefined || addToGraphics === false) {
        return graphics.outline;
    }
}

function drawDashedLine(graphics, startPoint, endPoint, dashArray, width, colour, alpha) {
    
    let followTintPattern = true;
    let colourToUse = config.DRAWING_COLOURS.WHITE;
    if(!graphics.outline) {
        //this is to handle the scenario where the drawLine call is coming from drawing a dimension line and so graphics is a single grpahhics object not an object with an outline property
        let passedInGraphicsObject = graphics;
        graphics = {};
        graphics.outline = passedInGraphicsObject;
        followTintPattern = false;
        colourToUse = colour || lineColour;
    }

    var dashCount = dashArray.length;

    graphics.outline
        .moveTo(startPoint.x, startPoint.y);

    var downLine = false;
    var dx, dy;
    dx = (endPoint.x - startPoint.x);
    if (endPoint.x === startPoint.x && endPoint.y < startPoint.y) {
        downLine = true;
        dy = (startPoint.y - endPoint.y);
    }else {
        dy = (endPoint.y - startPoint.y);
    }

    var slope = dy / dx;
    //if (dx === 0) {
    //    slope = 1; //if vertival line(slope will be infinity) then need to set slope to 1 so so that rest of code works
    //}
    var distRemaining = Math.sqrt(dx * dx + dy * dy);
    var dashIndex = 0;
    var draw = true;

    while (distRemaining >= 0.1)
    {
        var dashLength = dashArray[dashIndex++ % dashCount];
        if (dashLength > distRemaining) dashLength = distRemaining;
        var slopeDivideFactor;
        if (isFinite(slope)) {
            slopeDivideFactor = 1 + slope * slope;
        } else {
            slopeDivideFactor = 1;
        }
        var xStep = Math.sqrt(dashLength * dashLength / (slopeDivideFactor));

        if (dx < 0) {
            xStep = -xStep;
        }

        if (dx !== 0) {
            startPoint.x += xStep
        }
        
        var yStep;
        if (isFinite(slope)) {
            yStep = slope * xStep;
        } else {
            if (downLine === true) {
                yStep = -xStep;
            } else {
                yStep = xStep;
            }
            
        }
        startPoint.y += yStep;

        if (draw) {
            graphics.outline
                .lineTo(startPoint.x, startPoint.y)
                .stroke({ width: width || lineWidth, color: colour || lineColour, alpha: alpha || lineAlpha, pixelLine: usePixelLine });
        } else {
            graphics.outline.moveTo(startPoint.x, startPoint.y);
        }

        distRemaining -= dashLength;
        draw = !draw;
    }

}

function drawArc(centrePoint, startPoint, radius, startAngle, endAngle, graphics, width, colour, antiClockwise) {
    
    graphics.outline
        .moveTo(startPoint.x, startPoint.y)
        .arc(centrePoint.x, centrePoint.y, radius, startAngle, endAngle, antiClockwise || false)
        .stroke({ width: width || lineWidth, color: config.DRAWING_COLOURS.WHITE, pixelLine: usePixelLine, alpha: lineAlpha });

    if(graphics.outline.tint !== (colour || lineColour)) {
        graphics.outline.tint = colour || lineColour;
    }
    
}

//function drawArcNoScaling(centrePoint, startPoint, radius, startAngle, endAngle, colour, antiClockwise) {
//    graphicsObject.lineStyle(lineWidth, colour || lineColour);

//    //var startPoint;

//    //startPoint = { x: centrePoint.x + radius * Math.cos(startAngle), y: centrePoint.y + radius * Math.sin(startAngle) };

//    //graphicsObject.moveTo(Math.floor(startPoint.x * scalingFactor), mainHeight - (Math.floor(startPoint.y * scalingFactor)));
//    //graphicsObject.arc(Math.floor(centrePoint.x * scalingFactor), mainHeight - (Math.floor(centrePoint.y * scalingFactor)), Math.floor(radius * scalingFactor), startAngle, endAngle, antiClockwise || false);
//    graphicsObject.moveTo((startPoint.x), mainHeight - ((startPoint.y)));
//    graphicsObject.arc((centrePoint.x), mainHeight - ((centrePoint.y)), (radius), startAngle, endAngle, antiClockwise || false);
//}

function fillArc(fillColour, centrePoint, startPoint, endPoint, radius, startAngle, endAngle, graphics, width, colour, antiClockwise) {
    
    // var points = [centrePoint, startPoint, endPoint, centrePoint];
    
    drawArc(centrePoint, startPoint, radius, startAngle, endAngle, graphics, width, colour, antiClockwise);
    graphics.fill
        .moveTo(centrePoint.x, centrePoint.y)
        .lineTo(startPoint.x, startPoint.y)
        .arc(centrePoint.x, centrePoint.y, radius, startAngle, endAngle, antiClockwise || false)
        .closePath()
        .fill({ color: config.DRAWING_COLOURS.WHITE, alpha: 1 });

    if(graphics.fill.tint !== fillColour) {
        graphics.fill.tint = fillColour;
    }

    // drawPolygon(graphics, points, colour || lineColour, fillColour);
}

//function fillArcNoScaling(fillColour, centrePoint, startPoint, endPoint, radius, startAngle, endAngle, colour, antiClockwise) {
//    graphicsObject.beginFill(fillColour, 1);


//    var points = [centrePoint, startPoint, endPoint, centrePoint];
//    //drawLine(centrePoint, { x: centrePoint.x - radius, y: centrePoint.y }, true);
//    //drawLine(centrePoint, { x: centrePoint.x, y: centrePoint.y - radius }, true);
//    //drawLine({ x: centrePoint.x - radius, y: centrePoint.y }, { x: centrePoint.x, y: centrePoint.y - radius }, true);

//    drawArcNoScaling(centrePoint, startPoint, radius, startAngle, endAngle, colour, antiClockwise);
//    graphicsObject.endFill();
//    drawPolygonNoScaling(points, lineColour, fillColour);
//}

function drawDashedArc(centrePoint, startPoint, radius, startAngle, endAngle, graphicsObjectToUse, width, colour, antiClockwise) {
    var segmentCount = 40,
        theta = (endAngle - startAngle) / segmentCount;

    for (var i = 0; i < segmentCount; i += 2) {
        var sectorStartAngle = startAngle + (theta * i);
        var sectorEndAngle = sectorStartAngle + theta;
        var sectorStartPoint = i === 0 ? startPoint : {
            x: centrePoint.x + (radius * Math.cos(sectorStartAngle)),
            y: centrePoint.y + (radius * Math.sin(sectorStartAngle))
        };

        drawArc(
            centrePoint,
            sectorStartPoint,
            radius,
            sectorStartAngle,
            sectorEndAngle,
            graphicsObjectToUse,
            width,
            colour,
            antiClockwise
        );
    }
}

//function drawDashedArcNoScaling(centrePoint, startPoint, radius, startAngle, endAngle, colour, antiClockwise) {

//    var sweep = endAngle > startAngle ? endAngle - startAngle : startAngle - endAngle,
//        theta = sweep / 40;


//    for (var i = 0; i < 40; i++) {
//        if (i % 2 === 0) {
//            var sectorStartAngle = (startAngle + (theta * (i)));
//            var sectorEndAngle = sectorStartAngle + theta;
//            drawArcNoScaling(centrePoint, getArcStartPoint(startAngle + (theta * i), radius, centrePoint), radius, sectorStartAngle, sectorEndAngle, colour, antiClockwise);
//        }
//    }


//    function getArcStartPoint(startAngle, radius, centrePoint) {
//        var adjustedStartAngle;
//        var startX, startY;



//        if (startAngle >= 0 && startAngle < getRadians(90)) {
//            //bottom right
//            startX = centrePoint.x + radius * Math.abs(Math.cos(startAngle));
//            startY = centrePoint.y - radius * Math.abs(Math.sin(startAngle));
//        } else if (startAngle >= getRadians(90) && startAngle < getRadians(180)) {
//            //bottom left
//            startX = centrePoint.x - radius * Math.abs(Math.cos(startAngle));
//            startY = centrePoint.y - radius * Math.abs(Math.sin(startAngle));
//        } else if (startAngle >= getRadians(180) && startAngle < getRadians(270)) {
//            // top left
//            startX = centrePoint.x - radius * Math.abs(Math.cos(startAngle));
//            startY = centrePoint.y + radius * Math.abs(Math.sin(startAngle));
//        } else if (startAngle >= getRadians(270) && startAngle <= getRadians(360)) {
//            //top right
//            startX = centrePoint.x + radius * Math.abs(Math.cos(startAngle));
//            startY = centrePoint.y + radius * Math.abs(Math.sin(startAngle));
//        }

//        return { x: startX, y: startY };
//        function getRadians(angleDegrees) {
//            return (Math.PI / 180) * angleDegrees;
//            //Return Math.PI * angleInDegrees / 180.0
//        }
//    }


//}

//function drawRect(topLeft, topRight, bottomRight, bottomLeft, addToGraphics, optionalColour, optionalFillColour, optionalAlpha) {
//    var rectGraphicsObject;
//    if (addToGraphics === true) {
//        rectGraphicsObject = getGraphicsObject();
//    } else if (curAlternateGraphicsObject !== null){
//        rectGraphicsObject = curAlternateGraphicsObject;
//    } else {
//        rectGraphicsObject = new Graphics();
//    }
//    rectGraphicsObject.lineStyle(tableCellLineWidth, optionalColour || lineColour, optionalAlpha || lineAlpha);

//    if (optionalFillColour !== undefined) {
//        rectGraphicsObject.beginFill(optionalFillColour, optionalAlpha || 1);
//    }

//    //if (addToGraphics === true) {
//    //    rectGraphicsObject.moveTo(position.x, position.y);
//    //    rectGraphicsObject.lineTo(position.x + width, position.y);
//    //    rectGraphicsObject.lineTo(position.x + width, position.y + height);
//    //    rectGraphicsObject.lineTo(position.x, position.y + height);
//    //    rectGraphicsObject.lineTo(position.x, position.y);
//    //} else {
//    //    rectGraphicsObject.moveTo(position.x, position.y);
//    //    rectGraphicsObject.lineTo(position.x + width, position.y);
//    //    rectGraphicsObject.lineTo(position.x + width, position.y + height);
//    //    rectGraphicsObject.lineTo(position.x, position.y + height);
//    //    rectGraphicsObject.lineTo(position.x, position.y);
//    //}
//    rectGraphicsObject.moveTo(topLeft.x, topLeft.y);
//    rectGraphicsObject.lineTo(topRight.x, topRight.y);
//    rectGraphicsObject.lineTo(bottomRight.x, bottomRight.y);
//    rectGraphicsObject.lineTo(bottomLeft.x, bottomLeft.y);
//    rectGraphicsObject.lineTo(topLeft.x, topLeft.y);

//    if (optionalFillColour) {
//        rectGraphicsObject.endFill();
//    }

//    if (addToGraphics === false) {
//        return rectGraphicsObject;
//    } 
    
//}

// function drawRect(graphics, topLeft, topRight, bottomRight, bottomLeft, addToGraphics, optionalColour, optionalFillColour, optionalAlpha) {

//     if(!graphics.outline) {
//         let passedInGraphicsObject = graphics;
//         graphics = {};
//         graphics.outline = passedInGraphicsObject;
//     }

//     //if (addToGraphics === true) {
//     //    rectGraphicsObject.moveTo(position.x, position.y);
//     //    rectGraphicsObject.lineTo(position.x + width, position.y);
//     //    rectGraphicsObject.lineTo(position.x + width, position.y + height);
//     //    rectGraphicsObject.lineTo(position.x, position.y + height);
//     //    rectGraphicsObject.lineTo(position.x, position.y);
//     //} else {
//     //    rectGraphicsObject.moveTo(position.x, position.y);
//     //    rectGraphicsObject.lineTo(position.x + width, position.y);
//     //    rectGraphicsObject.lineTo(position.x + width, position.y + height);
//     //    rectGraphicsObject.lineTo(position.x, position.y + height);
//     //    rectGraphicsObject.lineTo(position.x, position.y);
//     //}
//     graphics.outline.moveTo(topLeft.x, topLeft.y);
//     graphics.outline.lineTo(topRight.x, topRight.y);
//     graphics.outline.lineTo(bottomRight.x, bottomRight.y);
//     graphics.outline.lineTo(bottomLeft.x, bottomLeft.y);
//     graphics.outline.lineTo(topLeft.x, topLeft.y);
//     // if (optionalFillColour) {
//     //     graphics.outline.closePath();
//     // }
//     graphics.outline.stroke({ width: tableCellLineWidth, color: optionalColour || lineColour, alpha: optionalAlpha || lineAlpha });

//     if (optionalFillColour !== undefined && !graphics.fill) {
//         graphics.outline.closePath();
//         graphics.outline.fill({ color: optionalFillColour, alpha: optionalAlpha || 1 });
//     } else if (optionalFillColour !== undefined && graphics.fill) {
        
//         graphics.fill.moveTo(topLeft.x, topLeft.y);
//         graphics.fill.lineTo(topRight.x, topRight.y);
//         graphics.fill.lineTo(bottomRight.x, bottomRight.y);
//         graphics.fill.lineTo(bottomLeft.x, bottomLeft.y);
//         graphics.fill.lineTo(topLeft.x, topLeft.y);
//         graphics.fill.closePath();

//         graphics.fill.fill({ color: optionalFillColour, alpha: optionalAlpha || 1 });
//     }

    

//     if (addToGraphics === false) {
//         return graphics.outline;
//     }

// }

function drawRect(graphicsObjectToUse, topLeft, topRight, bottomRight, bottomLeft, addToGraphics, optionalColour, optionalFillColour, optionalAlpha) {

    

    //if (addToGraphics === true) {
    //    rectGraphicsObject.moveTo(position.x, position.y);
    //    rectGraphicsObject.lineTo(position.x + width, position.y);
    //    rectGraphicsObject.lineTo(position.x + width, position.y + height);
    //    rectGraphicsObject.lineTo(position.x, position.y + height);
    //    rectGraphicsObject.lineTo(position.x, position.y);
    //} else {
    //    rectGraphicsObject.moveTo(position.x, position.y);
    //    rectGraphicsObject.lineTo(position.x + width, position.y);
    //    rectGraphicsObject.lineTo(position.x + width, position.y + height);
    //    rectGraphicsObject.lineTo(position.x, position.y + height);
    //    rectGraphicsObject.lineTo(position.x, position.y);
    //}
    graphicsObjectToUse.moveTo(topLeft.x, topLeft.y);
    graphicsObjectToUse.lineTo(topRight.x, topRight.y);
    graphicsObjectToUse.lineTo(bottomRight.x, bottomRight.y);
    graphicsObjectToUse.lineTo(bottomLeft.x, bottomLeft.y);
    graphicsObjectToUse.lineTo(topLeft.x, topLeft.y);
    if (optionalFillColour) {
        graphicsObjectToUse.closePath();
        // graphicsObjectToUse.endFill();
    }
    graphicsObjectToUse.stroke({ width: tableCellLineWidth, color: optionalColour || lineColour, alpha: optionalAlpha || lineAlpha, pixelLine: usePixelLine });

    if (optionalFillColour !== undefined) {
        graphicsObjectToUse.fill({ color: optionalFillColour, alpha: optionalAlpha || 1 });
    }

    

    if (addToGraphics === false) {
        return graphicsObjectToUse;
    }

}

//function drawInteractiveRect(callbacks, position, width, height, optionalColour, optionalFillColour, optionalAlpha) {
//    var rect = drawRect(position, width, height, false, optionalColour, optionalFillColour, optionalAlpha);
//    if (callbacks !== undefined) {
//        rect.interactive = true;
//        rect.buttonMode = true;
//        rect.hitArea = new PIXI.Rectangle(position.x, position.y, width, height);
//        if (callbacks.mouseover !== undefined && typeof callbacks.mouseover === 'function') {
//            rect.mouseover = callbacks.mouseover;
//        }
//        if (callbacks.click !== undefined && typeof callbacks.click === 'function') {
//            rect.click = callbacks.click;
//            rect.touchstart = callbacks.click;
//        }
//        if (callbacks.mouseout !== undefined && typeof callbacks.mouseout === 'function') {
//            rect.mouseout = callbacks.mouseout;
//        }
//    }
    
    

//    return rect;
//}

function makeRectInteractive(rect, hitAreaX, hitAreaY, callbacks) {
    
    if (callbacks !== undefined) {
        rect.eventMode = config.PIXI_EVENT_MODE.STATIC;
        rect.cursor = config.PIXI_CURSOR_OPTION.POINTER;
        if (rect.hitArea) {
            rect.hitArea = null;
        }
        rect.hitArea = new Rectangle(hitAreaX, hitAreaY, rect.width, rect.height);
        
        if (callbacks.mouseover !== undefined && typeof callbacks.mouseover === 'function') {
            // rect.mouseover = callbacks.mouseover;
            rect.on('mouseover', callbacks.mouseover);
        }
        if (callbacks.click !== undefined && typeof callbacks.click === 'function') {
            // rect.click = callbacks.click;
            rect.on('click', callbacks.click);
            // rect.touchstart = callbacks.click;
            rect.on('touchstart', callbacks.click);
        }
        if (callbacks.mouseout !== undefined && typeof callbacks.mouseout === 'function') {
            // rect.mouseout = callbacks.mouseout;
            rect.on('mouseout', callbacks.mouseout);
        }
        if (callbacks.mousemove !== undefined && typeof callbacks.mousemove === 'function') {
            // rect.mousemove = callbacks.mousemove;
            rect.on('mousemove', callbacks.mousemove);
        }
    }



    return rect;
}

function drawRectWithFixedBuffer(position, innerWidth, innerHeight, buffer, optionalColour, optionalFillColour, optionalAlpha) {
    var rectGraphicsObject;
    //if (addToGraphics === true) {
        rectGraphicsObject = getGraphicsObject();
    //} else {
    //    rectGraphicsObject = new Graphics();
    //}
    
    var x = Math.round((position.x + buffer) * scalingFactor) - buffer;
    var y = Math.round((position.y + buffer) * scalingFactor) - buffer;
    var width = Math.round(innerWidth * scalingFactor) + (buffer * 2);
    var height = Math.round(innerHeight * scalingFactor) + (buffer * 2);
    //if (addToGraphics === true) {
        rectGraphicsObject.moveTo(x, mainHeight - y );
        rectGraphicsObject.lineTo(x + width, mainHeight - y);
        rectGraphicsObject.lineTo(x + width, mainHeight - (y + height));
        rectGraphicsObject.lineTo(x, mainHeight - (y + height));
        rectGraphicsObject.lineTo(x, mainHeight - y);
    //} else {
        //rectGraphicsObject.moveTo(position.x, position.y);
        //rectGraphicsObject.lineTo(position.x + width, position.y);
        //rectGraphicsObject.lineTo(position.x + width, position.y + height);
        //rectGraphicsObject.lineTo(position.x, position.y + height);
        //rectGraphicsObject.lineTo(position.x, position.y);
    //}
    if (optionalFillColour) {
        rectGraphicsObject.closePath();
        // rectGraphicsObject.endFill();
    }

    rectGraphicsObject.stroke({ width: tableCellLineWidth, color: optionalColour || lineColour, alpha: optionalAlpha || lineAlpha, pixelLine: usePixelLine });

    if (optionalFillColour !== undefined) {
        rectGraphicsObject.fill({ color: optionalFillColour, alpha: optionalAlpha || 1 });
    }

    

    //if (addToGraphics === false) {
    //    return rectGraphicsObject;
    //}

}

// function drawPolygon(graphicsObjectToUse, points, colour, fillColour, width, alpha) {
//     //var polygonGraphicsObject = new Graphics();
    

//     for (var i = 0; i < points.length; i++) {
//         if (i == 0) {
//             //graphicsObject.moveTo(Math.round(points[i].x * scalingFactor), mainHeight - (Math.round(points[i].y * scalingFactor)));
//             graphicsObjectToUse.moveTo(points[i].x, points[i].y);
//         } else {
//             //graphicsObject.lineTo(Math.round(points[i].x * scalingFactor), mainHeight - (Math.round(points[i].y * scalingFactor)));
//             graphicsObjectToUse.lineTo(points[i].x, points[i].y);
//         }
//     }
//     graphicsObjectToUse.closePath();
//     if (fillColour !== undefined) {
//         var alphaVal = alpha || 1;
//         graphicsObjectToUse.fill({ color: fillColour, alpha: alphaVal });
//     } else {
//         // graphicsObjectToUse.fill({ color: config.DRAWING_COLOURS.WHITE, alpha: 0 });
//         graphicsObjectToUse.fill({ color: config.DRAWING_COLOURS.WHITE });
//     }
//     graphicsObjectToUse.stroke({ width: width || lineWidth, color: colour });
//     //if (fillColour !== undefined) {
    
//         // graphicsObjectToUse.endFill();
//     //}
//     //return polygonGraphicsObject;
// }

function drawPolygon(options) {
    //var polygonGraphicsObject = new Graphics();
    let {graphics, points, colour, fillColour, width, alpha, dontFill} = options;

    if(!graphics.outline) {
        //this is to handle the scenario where the drawLine call is coming from drawing a dimension line and so graphics is a single grpahhics object not an object with an outline property
        let passedInGraphicsObject = graphics;
        graphics = {};
        graphics.outline = passedInGraphicsObject;
    }
    drawPolygonPointGeometryOnGraphicsObject(graphics.outline, points);
    // for (var i = 0; i < points.length; i++) {
    //     if (i == 0) {
    //         //graphicsObject.moveTo(Math.round(points[i].x * scalingFactor), mainHeight - (Math.round(points[i].y * scalingFactor)));
    //         graphics.outline.moveTo(points[i].x, points[i].y);
    //     } else {
    //         //graphicsObject.lineTo(Math.round(points[i].x * scalingFactor), mainHeight - (Math.round(points[i].y * scalingFactor)));
    //         graphics.outline.lineTo(points[i].x, points[i].y);
    //     }
    // }
    // graphics.outline.closePath();
    graphics.outline.stroke({ width: width || lineWidth, color: config.DRAWING_COLOURS.WHITE, pixelLine: usePixelLine, alpha: lineAlpha });
    if(graphics.outline.tint !== (colour || lineColour)) {
        graphics.outline.tint = colour || lineColour;
    }
    
    
    if(!dontFill) {
        drawPolygonPointGeometryOnGraphicsObject(graphics.fill, points);
        if (fillColour !== undefined) {
            var alphaVal = alpha || 1;
            graphics.fill.fill({ color: config.DRAWING_COLOURS.WHITE, alpha: alphaVal });
            if(graphics.fill.tint !== fillColour) {
                graphics.fill.tint = fillColour;
            }
        } else {
            // graphicsObjectToUse.fill({ color: config.DRAWING_COLOURS.WHITE, alpha: 0 });
            graphics.fill.fill({ color: config.DRAWING_COLOURS.WHITE });
        }
    }
    //if (fillColour !== undefined) {
    
        // graphicsObjectToUse.endFill();
    //}
    //return polygonGraphicsObject;
}

function drawPolygonPointGeometryOnGraphicsObject(graphicsObject, points) {
    for (var i = 0; i < points.length; i++) {
        if (i == 0) {
            //graphicsObject.moveTo(Math.round(points[i].x * scalingFactor), mainHeight - (Math.round(points[i].y * scalingFactor)));
            graphicsObject.moveTo(points[i].x, points[i].y);
        } else {
            //graphicsObject.lineTo(Math.round(points[i].x * scalingFactor), mainHeight - (Math.round(points[i].y * scalingFactor)));
            graphicsObject.lineTo(points[i].x, points[i].y);
        }
    }
    graphicsObject.closePath();
}

//function drawPolygonNoScaling(points, colour, fillColour) {
//    //var polygonGraphicsObject = new Graphics();
//    if (fillColour !== undefined) {
//        graphicsObject.beginFill(fillColour, 1);
//    }
//    graphicsObject.lineStyle(lineWidth, colour);

//    for (var i = 0; i < points.length; i++) {
//        if (i == 0) {
//            //graphicsObject.moveTo(Math.round(points[i].x * scalingFactor), mainHeight - (Math.round(points[i].y * scalingFactor)));
//            graphicsObject.moveTo((points[i].x), mainHeight - ((points[i].y)));
//        } else {
//            //graphicsObject.lineTo(Math.round(points[i].x * scalingFactor), mainHeight - (Math.round(points[i].y * scalingFactor)));
//            graphicsObject.lineTo((points[i].x), mainHeight - ((points[i].y)));
//        }
//    }
//    if (fillColour !== undefined) {
//        graphicsObject.endFill();
//    }
    //return polygonGraphicsObject;
//}

// function drawCircle(graphicsObjectToUse, centrePoint, radius, colour, fillColour, width) {
    
//     graphicsObjectToUse.circle(centrePoint.x, centrePoint.y, radius);
//     // if (fillColour !== undefined) {
//     //     graphicsObjectToUse.closePath();
//     // }
//     if (fillColour !== undefined) {
//         graphicsObjectToUse.fill({ color: fillColour, alpha: 1 });
//     }
    
//     graphicsObjectToUse.stroke({ width: width || circleWidth, color: colour });
    
    

// }

function drawCircle(graphics, centrePoint, radius, colour, fillColour, width, bgColour) {
    
    graphics.outline.circle(centrePoint.x, centrePoint.y, radius);
    graphics.outline.stroke({ width: width || circleWidth, color: config.DRAWING_COLOURS.WHITE, pixelLine: usePixelLine, alpha: lineAlpha });
    if(graphics.outline.tint !== colour) {
        graphics.outline.tint = colour;
    }

    if (graphics.fill && fillColour !== undefined && !bgColour) {
        graphics.fill.circle(centrePoint.x, centrePoint.y, radius);
        graphics.fill.fill({ color: config.DRAWING_COLOURS.WHITE, alpha: 1 });
        
        if(graphics.fill.tint !== fillColour) {
            graphics.fill.tint = fillColour;
        }
    } else if (graphics.bg && bgColour !== undefined) {
        graphics.bg.circle(centrePoint.x, centrePoint.y, radius);
        graphics.bg.fill({ color: config.DRAWING_COLOURS.WHITE, alpha: 1 });
        if(graphics.bg.tint !== bgColour) {
            graphics.bg.tint = bgColour;
        }
        
    }
    
    
    
    

}

//function drawCircleNoScaling(centrePoint, radius, colour, fillColour) {
//    //var circleGraphicsObject = new Graphics();


//    if (fillColour !== undefined) {
//        graphicsObject.beginFill(fillColour, 1);
//    }
//    //else {
//    graphicsObject.lineStyle(circleWidth, colour);
//    //}

//    //graphicsObject.drawCircle(Math.round(centrePoint.x * scalingFactor), mainHeight - (Math.round(centrePoint.y * scalingFactor)), Math.round(radius * scalingFactor));
//    graphicsObject.drawCircle((centrePoint.x), mainHeight - ((centrePoint.y)), (radius));

//    if (fillColour !== undefined) {
//        graphicsObject.endFill();
//    }
//    //return circleGraphicsObject;
//}


function drawDashedCircle(graphicsObjectToUse, centrePoint, radius, dash, width, colour, alpha) {
    var pointArray = calcPointsCirc(centrePoint.x, centrePoint.y, radius, dash);
    
    for (var p = 0; p < pointArray.length; p++) {
        graphicsObjectToUse.moveTo(pointArray[p].x, pointArray[p].y);
        graphicsObjectToUse.lineTo(pointArray[p].ex, pointArray[p].ey);
    }
    graphicsObjectToUse.stroke({ width: width || lineWidth, color: colour || lineColour, alpha: alpha || lineAlpha, pixelLine: usePixelLine });
}


function calcPointsCirc(cx, cy, rad, dashLength) {
    var n = rad / dashLength,
        alpha = Math.PI * 2 / n,
        pointObj = {},
        points = [],
        i = -1;

    while (i < n) {
        var theta = alpha * i,
            theta2 = alpha * (i + 1);

        points.push({ x: (Math.cos(theta) * rad) + cx, y: (Math.sin(theta) * rad) + cy, ex: (Math.cos(theta2) * rad) + cx, ey: (Math.sin(theta2) * rad) + cy });
        i += 2;
    }
    return points;
}

function drawEllipse(graphicsObjectToUse, centrePoint, halfWidth, halfHeight, colour, fillColour, width) {
    
    graphicsObjectToUse.ellipse(centrePoint.x, centrePoint.y, halfWidth, halfHeight);
    if (fillColour !== undefined) {
        graphicsObjectToUse.closePath();
    }
    if (fillColour !== undefined) {
        graphicsObjectToUse.fill({ color: fillColour, alpha: 1 });
    }
    
    graphicsObjectToUse.stroke({ width: width || circleWidth, color: colour, pixelLine: usePixelLine, alpha: lineAlpha });
    
    

}

function drawDashedEllipse() {

}

//function drawDimension(dimension, addToGraphicsObject) {

//    var graphicsObj;

//    if (addToGraphicsObject !== undefined) {
//        graphicsObj = getGraphicsObject();
//    } else {
//        graphicsObj = new Graphics();
//    }

//    if (dimension.type.indexOf('cog') !== -1) {

//        var flipYAxisVal = mainHeight;// + dimension.totalTopLayerThickness;

//        graphicsObj.moveTo(dimension.ah1.tip.x, flipYAxisVal - dimension.ah1.tip.y);
//        graphicsObj.lineTo(dimension.ah1.sideAEnd.x, flipYAxisVal - dimension.ah1.sideAEnd.y);
//        graphicsObj.moveTo(dimension.ah1.tip.x, flipYAxisVal - dimension.ah1.tip.y);
//        graphicsObj.lineTo(dimension.ah1.sideBEnd.x, flipYAxisVal - dimension.ah1.sideBEnd.y);

//        graphicsObj.moveTo(dimension.ah2.tip.x, flipYAxisVal - dimension.ah2.tip.y);
//        graphicsObj.lineTo(dimension.ah2.sideAEnd.x, flipYAxisVal - dimension.ah2.sideAEnd.y);
//        graphicsObj.moveTo(dimension.ah2.tip.x, flipYAxisVal - dimension.ah2.tip.y);
//        graphicsObj.lineTo(dimension.ah2.sideBEnd.x, flipYAxisVal - dimension.ah2.sideBEnd.y);

//        graphicsObj.moveTo(dimension.lineStop1Start.x, flipYAxisVal - dimension.lineStop1Start.y);
//        graphicsObj.lineTo(dimension.lineStop1End.x, flipYAxisVal - dimension.lineStop1End.y);

//        graphicsObj.moveTo(dimension.lineStop2Start.x, flipYAxisVal - dimension.lineStop2Start.y);
//        graphicsObj.lineTo(dimension.lineStop2End.x, flipYAxisVal - dimension.lineStop2End.y);

//        var horizontalStartPoint = dimension.horizontalStartPoint;
//        var horizontalEndPoint = dimension.horizontalEndPoint;
//        var verticalStartPoint = dimension.verticalStartPoint;
//        var verticalEndPoint = dimension.verticalEndPoint;
//        var cogPoint = dimension.cogPoint;

//        //draw horizontal dimension portion
//        graphicsObj.moveTo(horizontalStartPoint.x, flipYAxisVal - horizontalStartPoint.y);
//        graphicsObj.lineTo(horizontalEndPoint.x, flipYAxisVal - horizontalEndPoint.y);
//        //draw vertical dimension portion
//        graphicsObj.moveTo(verticalStartPoint.x, flipYAxisVal - verticalStartPoint.y);
//        graphicsObj.lineTo(verticalEndPoint.x, flipYAxisVal - verticalEndPoint.y);
//        //draw vertical portion to COG marker connecting line
//        //graphicsObj.moveTo(verticalStartPoint.x, verticalStartPoint.y);
//        graphicsObj.lineTo(cogPoint.x, flipYAxisVal - cogPoint.y);
//        //draw cog marker to horizontal portion connecting line
//        graphicsObj.lineTo(horizontalEndPoint.x, flipYAxisVal - horizontalEndPoint.y);
        

//        var verticalText = new PIXI.Text("" + dimension.displayLengthVertical, { font: dimension.font, fill: dimension.fontColour, align: 'center', fontWeight: fontWeight });

//        //if (dimension.interaction !== undefined) {
//        //    if (dimension.interaction.callbacks !== undefined) {
//        //        text.interactive = true;
//        //        text.buttonMode = true;
//        //        if (dimension.interaction.callbacks.mouseover !== undefined && typeof dimension.interaction.callbacks.mouseover === 'function') {
//        //            text.mouseover = dimension.interaction.callbacks.mouseover;
//        //        }
//        //        if (dimension.interaction.callbacks.click !== undefined && typeof dimension.interaction.callbacks.click === 'function') {
//        //            text.click = dimension.interaction.callbacks.click;
//        //            text.touchstart = dimension.interaction.callbacks.click;
//        //        }
//        //        if (dimension.interaction.callbacks.mouseout !== undefined && typeof dimension.interaction.callbacks.mouseout === 'function') {
//        //            text.mouseout = dimension.interaction.callbacks.mouseout;
//        //        }
//        //    }
//        //}

//        verticalText.anchor = new Point(0.5, 0.5);

//        var verticalTextBackground = new Graphics();

//        verticalTextBackground.x = dimension.verticalTextCentre.x;
//        verticalTextBackground.y = mainHeight - dimension.verticalTextCentre.y;
//        verticalText.x = dimension.textBackgroundWidth / 2;
//        verticalText.y = dimension.textBackgroundHeight / 2;
        
//        verticalText.rotation = dimension.rotateText;
        

//        verticalTextBackground.beginFill(config.DRAWING_COLOURS.WHITE, 1);
//        verticalTextBackground.drawRect(0, 0, dimension.textBackgroundWidth, dimension.textBackgroundHeight);
//        verticalTextBackground.endFill();
//        verticalTextBackground.addChild(verticalText);
//        graphicsObj.addChild(verticalTextBackground);


//        var horizontalText = new PIXI.Text("" + dimension.displayLengthHorizontal, { font: dimension.font, fill: dimension.fontColour, align: 'center', fontWeight: fontWeight });

//        //if (dimension.interaction !== undefined) {
//        //    if (dimension.interaction.callbacks !== undefined) {
//        //        text.interactive = true;
//        //        text.buttonMode = true;
//        //        if (dimension.interaction.callbacks.mouseover !== undefined && typeof dimension.interaction.callbacks.mouseover === 'function') {
//        //            text.mouseover = dimension.interaction.callbacks.mouseover;
//        //        }
//        //        if (dimension.interaction.callbacks.click !== undefined && typeof dimension.interaction.callbacks.click === 'function') {
//        //            text.click = dimension.interaction.callbacks.click;
//        //            text.touchstart = dimension.interaction.callbacks.click;
//        //        }
//        //        if (dimension.interaction.callbacks.mouseout !== undefined && typeof dimension.interaction.callbacks.mouseout === 'function') {
//        //            text.mouseout = dimension.interaction.callbacks.mouseout;
//        //        }
//        //    }
//        //}

//        horizontalText.anchor = new Point(0.5, 0.5);

//        var horizontalTextBackground = new Graphics();

//        horizontalTextBackground.x = dimension.horizontalTextCentre.x;
//        horizontalTextBackground.y = mainHeight - dimension.horizontalTextCentre.y;
//        horizontalText.x = dimension.textBackgroundHeight / 2;
//        horizontalText.y = dimension.textBackgroundWidth / 2;

//        //verticalText.rotation = dimension.rotateText;


//        horizontalTextBackground.beginFill(config.DRAWING_COLOURS.WHITE, 1);
//        horizontalTextBackground.drawRect(0, 0, dimension.textBackgroundHeight, dimension.textBackgroundWidth);
//        horizontalTextBackground.endFill();
//        horizontalTextBackground.addChild(horizontalText);
//        graphicsObj.addChild(horizontalTextBackground);

//    } else {
//        if (dimension.style !== config.DIMENSION_STYLE.COG) {
//            graphicsObj.lineStyle(dimensionLineWidth, config.DRAWING_COLOURS.BLACK, 1);
//        } else {
//            graphicsObj.lineStyle(dimensionLineWidth, config.DRAWING_COLOURS.BLUE, 1);
//        }

//        if (dimension.style !== config.DIMENSION_STYLE.POP_LAYER) {
//            //if (dimension.jumpingLeft === undefined && dimension.jumpingDown === undefined) {
//            if (dimension.style !== config.DIMENSION_STYLE.COG) {
//                //arrow head 1
//                graphicsObj.moveTo(dimension.ah1.tip.x, dimension.ah1.tip.y);
//                graphicsObj.lineTo(dimension.ah1.sideAEnd.x, dimension.ah1.sideAEnd.y);
//                graphicsObj.moveTo(dimension.ah1.tip.x, dimension.ah1.tip.y);
//                graphicsObj.lineTo(dimension.ah1.sideBEnd.x, dimension.ah1.sideBEnd.y);
//            }
//            // line stop 1
//            graphicsObj.moveTo(dimension.lineStop1Start.x, dimension.lineStop1Start.y);
//            graphicsObj.lineTo(dimension.lineStop1End.x, dimension.lineStop1End.y);
//            //}

//            //main line 1
//            graphicsObj.moveTo(dimension.lineStart.x, dimension.lineStart.y);
//            graphicsObj.lineTo(dimension.lineEnd.x, dimension.lineEnd.y);

//            if (dimension.style !== config.DIMENSION_STYLE.COG) {
//                //main line 2
//                graphicsObj.moveTo(dimension.lineStart2.x, dimension.lineStart2.y);
//                graphicsObj.lineTo(dimension.lineEnd2.x, dimension.lineEnd2.y);


//                //if (dimension.jumpingRight === undefined && dimension.jumpingUp === undefined) {
//                // arrow head 2
//                graphicsObj.moveTo(dimension.ah2.tip.x, dimension.ah2.tip.y);
//                graphicsObj.lineTo(dimension.ah2.sideAEnd.x, dimension.ah2.sideAEnd.y);
//                graphicsObj.moveTo(dimension.ah2.tip.x, dimension.ah2.tip.y);
//                graphicsObj.lineTo(dimension.ah2.sideBEnd.x, dimension.ah2.sideBEnd.y);

//                //line stop 2
//                graphicsObj.moveTo(dimension.lineStop2Start.x, dimension.lineStop2Start.y);
//                graphicsObj.lineTo(dimension.lineStop2End.x, dimension.lineStop2End.y);
//                //}
//            }

//        }
//        var fontWeight;
//        if (dimension.style === config.DIMENSION_STYLE.COG) {
//            fontWeight = 'bold';
//        }
//        var text = new PIXI.Text("" + dimension.displayLength, { font: dimension.font, fill: dimension.fontColour, align: 'center', fontWeight: fontWeight });

//        if (dimension.interaction !== undefined) {
//            if (dimension.interaction.callbacks !== undefined) {
//                text.interactive = true;
//                text.buttonMode = true;
//                if (dimension.interaction.callbacks.mouseover !== undefined && typeof dimension.interaction.callbacks.mouseover === 'function') {
//                    text.mouseover = dimension.interaction.callbacks.mouseover;
//                }
//                if (dimension.interaction.callbacks.click !== undefined && typeof dimension.interaction.callbacks.click === 'function') {
//                    text.click = dimension.interaction.callbacks.click;
//                    text.touchstart = dimension.interaction.callbacks.click;
//                }
//                if (dimension.interaction.callbacks.mouseout !== undefined && typeof dimension.interaction.callbacks.mouseout === 'function') {
//                    text.mouseout = dimension.interaction.callbacks.mouseout;
//                }
//            }
//        }

//        text.anchor = new Point(0.5, 0.5);

//        var textBackground = new Graphics();

//        textBackground.x = dimension.textCentre.x;
//        textBackground.y = dimension.textCentre.y;
//        text.x = dimension.textBackgroundWidth / 2;
//        text.y = dimension.textBackgroundHeight / 2;
//        if (dimension.rotateText) {
//            //text.pivot = new Point(0.5, 0.5);
//            text.rotation = dimension.rotateText;
//            //text.x = 2;//(dimension.length - 2) / 2;
//            //text.y = 4;//dimension.lineStart.y;

//        }
//        //else {
//        //    text.x = 4;//(dimension.length - 2) / 2;
//        //    text.y = 2;//dimension.lineStart.y;

//        //}

//        textBackground.beginFill(config.DRAWING_COLOURS.WHITE, 1);
//        textBackground.drawRect(0, 0, dimension.textBackgroundWidth, dimension.textBackgroundHeight);
//        textBackground.endFill();
//        textBackground.addChild(text);
//        graphicsObj.addChild(textBackground);
//    }


//    if (addToGraphicsObject === undefined) {
//        return graphicsObj;
//    }
    
//}

function getTrialWatermarkSprite(imageSource) {
    return watermarkSprite;
}

function loadImageResources() {
    var dfd = $.Deferred();
    if (watermarkSprite === null) {
        //if (_resources !== undefined && _resources['watermark'] !== undefined) {
        //    watermarkSprite = new PIXI.Sprite(_resources.watermark.texture);
        //    watermarkSprite.alpha = 0.5;
        //    dfd.resolve();
        //} else {
        // PIXI.loader.reset();
        //     var loader = PIXI.loader.add('watermark', "img/app/Logo_TrialStamp.png").load(function (loader, resources) {
        //         _resources = resources;
        //         watermarkSprite = new PIXI.Sprite(resources.watermark.texture);
        //         watermarkSprite.alpha = 0.2;
        //         dfd.resolve();
        //     })
        // let loader = PIXI.Loader.shared;
        // loader.reset();
        // loader.add('watermark', "img/app/Logo_TrialStamp.png").load(function (loader, resources) {
        //     _resources = resources;
        //     watermarkSprite = new PIXI.Sprite(resources.watermark.texture);
        //     watermarkSprite.alpha = 0.2;
        //     dfd.resolve();
        // })
        //}
    let trialWaterMarkPath = '/img/app/Logo_TrialStamp.png';
        Assets.load([
        trialWaterMarkPath]).then((assets) => {
            _resources = assets;
            watermarkSprite = new Sprite(assets[trialWaterMarkPath]);
            watermarkSprite.alpha = 0.2;
            watermarkSprite.eventMode = config.PIXI_EVENT_MODE.NONE;
            dfd.resolve();
        });

    } else {
        dfd.resolve();
    }
    

    return dfd.promise();
}

function getDrawingContainer(position, width, height, optionalBGFillColour, optionalBorderColor) {
    var drawingArea = new Container();
    drawingArea.eventMode = config.PIXI_EVENT_MODE.NONE;
    drawingArea.x = position.x;
    drawingArea.y = position.y;
    //topDrawingArea.width = topWidth;
    //drawingArea.height = height;
    addBackground(drawingArea, width, height, optionalBGFillColour, optionalBorderColor);
    // addBackground(drawingArea, width, height, optionalBGFillColour, config.DRAWING_COLOURS.RED);
    return drawingArea;
}

function getDrawingContainerEventModePassive(position, width, height, optionalBGFillColour, optionalBorderColor) {
    var drawingArea = new Container();
    drawingArea.eventMode = config.PIXI_EVENT_MODE.PASSIVE;
    drawingArea.x = position.x;
    drawingArea.y = position.y;
    //topDrawingArea.width = topWidth;
    //drawingArea.height = height;
    addBackground(drawingArea, width, height, optionalBGFillColour, optionalBorderColor);
    // addBackground(drawingArea, width, height, optionalBGFillColour, config.DRAWING_COLOURS.RED);
    return drawingArea;
}

function getInteractiveContainer(callbacks, position, width, height, optionalBGFillColour) {
    var interactiveContainer = getDrawingContainer(position, width, height, optionalBGFillColour);

    if (callbacks !== undefined) {
        interactiveContainer.eventMode = config.PIXI_EVENT_MODE.STATIC;
        interactiveContainer.hitArea = new Rectangle(0, 0, width, height);
        if (callbacks.mouseover !== undefined && typeof callbacks.mouseover === 'function') {
            // interactiveContainer.mouseover = callbacks.mouseover;
            interactiveContainer.on('mouseover', callbacks.mouseover);
        }
        if (callbacks.click !== undefined && typeof callbacks.click === 'function') {
            // interactiveContainer.click = callbacks.click;
            interactiveContainer.on('click', callbacks.click);
        }
        if (callbacks.mousemove !== undefined && typeof callbacks.mousemove === 'function') {
            // interactiveContainer.mousemove = callbacks.mousemove;
            interactiveContainer.on('mousemove', callbacks.mousemove);
        }
        if (callbacks.mouseout !== undefined && typeof callbacks.mouseout === 'function') {
            // interactiveContainer.mouseout = callbacks.mouseout;
            interactiveContainer.on('mouseout', callbacks.mouseout);
        }
    }
    
    return interactiveContainer;
}

function addBackground(container, w, h, bgColour, borderColor) {
    var bg = new Graphics();
    bg.eventMode = config.PIXI_EVENT_MODE.NONE;
    if ((bgColour !== undefined && bgColour !== null) || borderColor !== undefined && borderColor !== null) {
        bg.rect(0, 0, w, h);
    }
    if (bgColour !== undefined && bgColour !== null) {
        bg.closePath();
    }
    if (bgColour !== undefined && bgColour !== null) {
        bg.fill({ color: bgColour });
    }
    if (borderColor !== undefined && borderColor !== null) {
        bg.stroke({ width: 1, color: borderColor, pixelLine: usePixelLine, alpha: lineAlpha });
        bg.lineColour = borderColor;
    }
    

    container.addChild(bg);
}

async function getRenderer(width, height, options) {
    if (!app) {
        const candidate = new Application();
        app = candidate;
        // Readiness belongs to the shared Application, not a render consumer.
        // Every consumer must await init, even after another render is cancelled.
        appInitialisation = (async () => {
            await candidate.init({
                width: width,
                height: height,
                antialias: true,
                clearBeforeRender: true,
                backgroundColor: config.DRAWING_COLOURS.WHITE,
                backgroundAlpha: 1,
                resolution: window.devicePixelRatio || 1,
                autoDensity: true,
                ...options
            });
            if (candidate.renderer.background) {
                candidate.renderer.background.color = config.DRAWING_COLOURS.WHITE;
                candidate.renderer.background.alpha = 1;
            }
            deprecation.quiet = true;
            candidate.canvas.style.backgroundColor = '#FFFFFF';
            return candidate;
        })().catch(error => {
            // A retired Application must not reset a newer initialization.
            if (app === candidate) {
                app = null;
                appInitialisation = null;
            }
            throw error;
        });
    }
    return appInitialisation;
}

function nullApp() {
    app = null;
    appInitialisation = null;
}

function setWaterMarkSpriteToNull() {
    watermarkSprite = null;
}

function getPolygon(points) {
    return new Polygon(points);
}

function getRect(x, y, width, height) {
    return new Rectangle(x, y, width, height);
}

var pixiAdapter = {
    drawText: drawText,
    drawLine: drawLine,
    drawDashedLine: drawDashedLine,
    drawArc: drawArc,
    drawPolygon: drawPolygon,
    drawCircle: drawCircle,
    drawDashedCircle:drawDashedCircle,
    getRenderer: getRenderer,
    setScalingFactor: setScalingFactor,
    //drawDimension: drawDimension,
    drawRect: drawRect,
    getDrawingContainer: getDrawingContainer,
    getGraphicsObject: getGraphicsObject,
    setMainHeight: setMainHeight,
    setWordWrapWidth: setWordWrapWidth,
    fillArc: fillArc,
    drawRectWithFixedBuffer: drawRectWithFixedBuffer,
    drawDashedArc: drawDashedArc,
    getTrialWatermarkSprite: getTrialWatermarkSprite,
    loadImageResources: loadImageResources,
    makeRectInteractive: makeRectInteractive,
    drawInteractiveTextIcon: drawInteractiveTextIcon,
    getInteractiveContainer: getInteractiveContainer,
    //drawArcNoScaling: drawArcNoScaling,
    //fillArcNoScaling: fillArcNoScaling,
    //drawDashedArcNoScaling: drawDashedArcNoScaling,
    //drawCircleNoScaling: drawCircleNoScaling,
    getPoint: getPoint,
    getNewGraphicsObject: getNewGraphicsObject,
    setAlternateGraphicsObject: setAlternateGraphicsObject,
    destroyGraphicsObject: destroyGraphicsObject,
    setWaterMarkSpriteToNull: setWaterMarkSpriteToNull,
    getPolygon: getPolygon,
    getRect: getRect,
    drawEllipse: drawEllipse,
    getDrawingContainerEventModePassive: getDrawingContainerEventModePassive,
    nullApp: nullApp,
    // drawDashedEllipse: drawDashedEllipse
    //setTopOffsetRequiredForAxisFlip: setTopOffsetRequiredForAxisFlip

}
export default pixiAdapter;


